export interface BrandConfigColors {
  primary: string;
  secondary: string;
  tertiary: string;
  primaryComplement?: string;
  secondaryComplement?: string;
  textColor: string;
  btnPrimaryText: string;
  btnSecondaryText: string;
  btnTertiaryText: string;
}

export interface BrandConfig {
  key: string;
  displayName: string;
  gptName: string;
  logoUrl: string;
  logoFormat: "png" | "svg";
  colors: BrandConfigColors;
}

export const DEFAULT_BRAND_KEY = "default";

export const DEFAULT_BRAND_CONFIG: BrandConfig = {
  key: DEFAULT_BRAND_KEY,
  displayName: "Gail",
  gptName: "GailGPT",
  logoUrl: "/icons/gail2-logo.svg",
  logoFormat: "svg",
  colors: {
    primary: "0 98 226",
    secondary: "235 207 254",
    tertiary: "229 231 235",
    textColor: "0 0 0",
    btnPrimaryText: "255 255 255",
    btnSecondaryText: "75 85 99",
    btnTertiaryText: "75 85 99",
  },
};

const REDIS_BRAND_KEY_PREFIX = "branding_";

export function getBrandRedisKey(brandKey: string): string {
  return `${REDIS_BRAND_KEY_PREFIX}${brandKey}`;
}
